/**
 * 인증 관련 상수 정의
 */

/**
 * SessionStorage 키
 */
export const AUTH_STORAGE_KEYS = {
  REDIRECT_AFTER_LOGIN: 'redirect_after_login',
  REDIRECT_TIMESTAMP: 'auth_redirect_timestamp',
  REFRESH_TRIED: 'auth_refresh_tried',
  KEYCLOAK_STATE: 'keycloak_state',
} as const;

/**
 * OAuth 콜백 재시도 설정
 */
export const CALLBACK_RETRY_CONFIG = {
  MAX_RETRIES: 10, // 최대 10회 재시도
  RETRY_INTERVAL: 1000, // 1초마다 재시도 (ms)
} as const;

/**
 * 리다이렉트 쿨다운 설정
 */
export const REDIRECT_CONFIG = {
  COOLDOWN_MS: 10000, // 10초 내 재시도 방지
} as const;

/**
 * OAuth 경로
 */
export const AUTH_ROUTES = {
  CALLBACK: '/callback',
  UNAUTHORIZED: '/unauthorized',
} as const;
